import { filter } from 'lodash'
import { combineReducers } from 'redux'
import { loadingReducer } from 'redux-foundry'
import {
  API_LISTAR_ESPECIE_SILVICULTURA,
  API_CRIAR_ESPECIE_SILVICULTURA,
  API_EXCLUIR_ESPECIE_SILVICULTURA,
  API_ATUALIZAR_ESPECIE_SILVICULTURA,
} from 'store/modules/api/especieSilvicultura.actions'

const lista = (state = [], { type, payload }) => {
  switch (type) {
    case API_LISTAR_ESPECIE_SILVICULTURA.success:
      return payload.sort((a, b) => a.especie.localeCompare(b.especie))
    case API_CRIAR_ESPECIE_SILVICULTURA.success:
      return [...state, payload].sort((a, b) => a.especie.localeCompare(b.especie))
    case API_ATUALIZAR_ESPECIE_SILVICULTURA.success:
      return state.map((e) => (e.id === payload.id ?
        payload : e))
    case API_EXCLUIR_ESPECIE_SILVICULTURA.success:
      return filter(state, (o) => o.id !== Number(payload))
    default: return state
  }
}

const isCarregandoLista = loadingReducer(false, API_LISTAR_ESPECIE_SILVICULTURA)

const isSaving = loadingReducer(false, API_CRIAR_ESPECIE_SILVICULTURA)
const isUpdate = loadingReducer(false, API_ATUALIZAR_ESPECIE_SILVICULTURA)

export default combineReducers({
  lista,
  isCarregandoLista,
  isSaving,
  isUpdate,
})
